<template>
  <div id="noticeIndex">
    <div class="shade" id="guideCloseNotice" v-show="show" @click="show = false"></div>
    <div class="btn pointer" id="guideNotice">
      <el-popover placement="bottom-start" popper-class="guideNotice" :width="200" trigger="click" :teleported="false" ref="popover" :visible="show">
        <template #reference>
          <el-badge :value="SumBadge" id="guideBtn" class="item" :hidden="SumBadge == 0">
            <span class="el-dropdown-link" id="guideClickNotice" @click="show = true">
              <i class="iconfont" style="font-size: 22px" id="message">&#xe669;</i>
            </span>
          </el-badge>
        </template>
        <div class="popDiv">
          <div class="item" @click="onClick">
            系统公告(<span style="color: red">{{ count }}</span
            >)
          </div>
          <el-divider />
          <div class="item">
            <total-card :list="dwspList" label="待我审批" :count="dwspCount" :type="1" @jump="jump"></total-card>
          </div>
          <div class="item">
            <total-card :list="cswdList" label="抄送我的" :count="cswdCount" :type="2" @jump="jump"></total-card>
          </div>
          <div class="item">
            <total-card :list="cysyjList" label="超预算预警" :count="cysyjCount" :type="3" @jump="jump"></total-card>
          </div>
        </div>
      </el-popover>
    </div>
    <el-drawer custom-class="drawerNotice" v-model="isPop" size="40%" @opened="onOpened">
      <template #header>
        <div>系统公告</div>
      </template>
      <NoticeMain ref="noticeMain" @details="onDetails" />
    </el-drawer>
    <el-drawer v-model="isPopDetails" size="80%" @close="onOpened" destroy-on-close>
      <notice-details :c-content="nowItem.cContent" :c-notices-id="nowItem.cNoticesID" />
    </el-drawer>
    <el-popover placement="bottom" :width="200" ref="popoverRef" trigger="click">
      <template #default>
        <div class="table">
          <el-table :data="list" height="100%">
            <el-table-column prop="companyNumber" label="企业号" min-width="60" />
            <el-table-column prop="companyName" label="企业名称" min-width="90" />
            <el-table-column prop="subName" label="账套名称" min-width="90" />
            <el-table-column v-if="type != 3" prop="count" label="审批单据数" min-width="90" />
            <el-table-column v-else prop="count" label="超预算项目" min-width="90" />
            <el-table-column label="操作" min-width="50">
              <!-- <template #default="{ row }">
              <el-link :underline="false" type="primary" @click="onClickLook(row)">查看</el-link>
            </template> -->
            </el-table-column>
          </el-table>
        </div>
      </template>
    </el-popover>
  </div>
</template>
<script lang="ts" setup>
import noticeApi from "@/api/noticeApi/noticeApi";
import { ElMessageBox, ElPopover } from "element-plus";
import { ref, watchPostEffect, watch, unref } from "vue";
import NoticeMain from "./noticeMain.vue";
import { useNoticeIndex } from "./useNotice";
import NoticeDetails from "./noticeDetails.vue";
import { GetUserMessageListResponse } from "@/api/noticeApi/noticeLimit";
import _ from "lodash";
import store from "@/store";
import totalCard, { List } from "@/components/totalCard/totalCard.vue";
import { Badge } from "@/store/interface/common";
const SumBadge = ref(0);
//#region 消息
const show = ref(false);
var ele = document.getElementsByTagName("body");
// ele[0].addEventListener("click", (e: any) => {
//   console.log(e);
//   var id = e.target.id;
//   if (id != "message") {
//     show.value = false;
//   }
// });
//#endregion

//#region 下拉菜单
const popoverRef = ref();
const dropdownref = ref();
const dropDowmCommand = (command: string) => {
  if (command == "1") {
    onClick();
    dropdownref.value.handleClose();
  } else if (command == "2") {
    list.value = dwspList.value;
    type.value = 1;
    unref(popoverRef).popperRef?.delayHide?.();
  } else if (command == "3") {
    list.value = cswdList.value;
    type.value = 2;
    unref(popoverRef).popperRef?.delayHide?.();
  } else if (command == "4") {
    list.value = cysyjList.value;
    type.value = 3;
    unref(popoverRef).popperRef?.delayHide?.();
  }
};
//#endregion

//#region 公告
const { count, getUserCount } = useNoticeIndex();
const nowItem = ref({} as GetUserMessageListResponse);
const isPop = ref<boolean>(false);
const isPopDetails = ref<boolean>(false);

const noticeMain = ref();
const onOpened = () => {
  noticeMain.value?.getUserMessageList();
  getUserCount();
};
const onClick = () => {
  isPop.value = true;
};

const onDetails = (item: GetUserMessageListResponse) => {
  console.log(item);

  nowItem.value = item;
  isPopDetails.value = true;
};

noticeApi.GetUserNotReadNotice().then(({ data }: any) => {
  if (!data) return;
  ElMessageBox.confirm(data.cTitle, "系统公告", {
    showCancelButton: false,
    confirmButtonText: "详情",
  })
    .then(async () => {
      onDetails(data);
    })
    .catch(() => {
      const params = { cnoticeid: data.cNoticesID };
      noticeApi.AddUserKnowMsgLog(params);
    });
});
//#endregion

//#region 各模块待审数量
const list = ref<List[]>([]);
const type = ref<number>(0);
const dwspList = ref<List[]>([]);
const cswdList = ref<List[]>([]);
const cysyjList = ref<List[]>([]);
const dwspCount = ref(0);
const cswdCount = ref(0);
const cysyjCount = ref(0);

watchPostEffect(() => {
  cysyjList.value = [];
  cysyjCount.value = 0;
  cswdList.value = [];
  cswdCount.value = 0;
  dwspList.value = [];
  dwspCount.value = 0;
  const badges = store.getters.getBadges;
  console.log(badges, "badges");
  badges.forEach((badge: Badge) => {
    let count = 0;
    let cswCount = 0;
    let ysCount = 0;
    const data = {
      companyNumber: badge.companyNumber,
      companyName: badge.companyName,
    };
    badge.list.forEach((list) => {
      if (list.moduleType == "dsp") {
        count = list.count;
      } else if (list.moduleType == "csw") {
        cswCount = list.count;
      } else if (list.moduleType == "ys") {
        ysCount = list.count;
        list.subList?.forEach((item) => {
          cysyjList.value.push({
            ...data,
            count: item.count,
            subName: item.subName ?? "",
            subId: item.subId,
          });
        });
      }
    });
    if (count) dwspList.value.push({ ...data, count, subName: "", subId: "" });
    if (cswCount) cswdList.value.push({ ...data, count: cswCount, subName: "", subId: "" });
    //if (ysCount) cysyjList.value.push({ ...data, count: ysCount });
  });
  cswdCount.value = [0, ...cswdList.value.map((l: List) => l.count)].reduce((a: number, b: number) => a + b) || 0;
  dwspCount.value = [0, ...dwspList.value.map((l: List) => l.count)].reduce((a: number, b: number) => a + b) || 0;
  cysyjCount.value = [0, ...cysyjList.value.map((l: List) => l.count)].reduce((a: number, b: number) => a + b) || 0;
});
//#endregion

watch([count, cswdCount, dwspCount, cysyjCount], ([a, b, c, d]) => {
  console.log("watchwatchwatchwatch");
  SumBadge.value = a + b + c + d;
});

const emits = defineEmits(["jump"]);
//公告提醒,预算点击跳转处理
const jump = (data: any) => {
  emits("jump", data);
};
</script>
<style lang="less" scoped>
@bg: rgb(247 247 247);
#noticeIndex {
  margin-right: @padding;
  padding: 7px;
  .guide {
    z-index: 100005;
    background: @bg;
    &::after {
      content: "";
      position: absolute;
      background: @bg;
      width: 100%;
      height: 7px;
      top: 100%;
      left: 0;
    }
  }
  .btn {
    margin: 0;
  }
  .el-badge {
    padding: 7px;
    :deep(.el-badge__content) {
      top: 7px;
      right: 13px;
    }
  }
  :deep(.el-popper) {
    .popDiv {
      display: flex;
      flex-flow: column;
      justify-content: center;
      .item {
        padding: 5px !important;
        width: 100%;
      }
      .item:hover {
        background-color: #ecf5ff;
        color: #409eff;
      }
      .el-divider {
        margin: 0;
      }
    }
    .table {
      height: 200px;
      .el-link {
        font-size: @fontSize;
        font-weight: normal;
      }
    }
  }
  .shade {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    left: 0;
  }
}

:deep(.drawerNotice) {
  .el-drawer__header {
    margin: 0;
    line-height: 30px;
    padding: 8px 20px;
    background: #f5f8fd;
    color: #000;
    font-size: 14px;
  }
}
</style>
